import { gql } from "apollo-boost";

export const UPDATE_PASSWORD_USER = gql`
mutation UpdatePasswordUserMedicalOffice($data: updatePasswordUserMedicalOfficeInput) {
    UpdatePasswordUserMedicalOffice(data: $data)
    }
`